<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <EnterpriseAdminSidebarMenu  :show_menu="false" :show_back_button="false" back_link="enterpriseadminreports" />

      <nav id="sidebar1" 
        class="show_back_button"
      >
        <ul class="list-unstyled">
          <li class="" style="cursor: pointer;" @click="backtoCompetencyReport()">
            
              <img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />
              Back
            
          </li>
        </ul>
      </nav>

      <div class="content-wrapper padding-left-165">
        <div class="container-wrapper center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>
          <div>
          <iframe id="pdf-frame" style="display: none;"></iframe>
          <div class="my-3"></div>
          <div class="row mt-3 mb-3 pb-2">
            <div class="col-3 float-left text-left">
              <h3 class="d-inline heading text-uppercase">Competency Progress</h3>
            </div>
            <div class="col-6 p-0" style="text-align: center; margin: 0 auto;">
              <button
                  :disabled="((this.page) && (this.page == 0))"
                  @click="previousPagination()"
                  class=" btn ma-blue-btn btn-md font-weight-bold rounded-pill"
                  style="padding-top: 3px; padding-bottom: 3px;margin-right: 20px; margin-top: -10px;"
                  >Previous</button>
              <span class="h4 text-uppercase" v-if="isOverviewVisible && loading == false">{{ menteeName }}</span>
              <button
                  :disabled="((this.page >= 0) && ((parseInt(this.page) + parseInt(1)) === this.total_pages))"
                  @click="nextPagination()"
                  class=" btn ma-blue-btn btn-md font-weight-bold rounded-pill" 
                  style="padding-top: 3px; padding-bottom: 3px;margin-left: 20px; margin-top: -10px;"
                  >Next</button>
            </div>
            <div class="col-3 text-right pl-0">
              <div class="margin-t-2 float-right pl-2" v-if="subtasks.length > 0" @click="shareButtonModal()">
                <img class="cursor-pointer" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px" style="padding-top: 2px; " />
              </div>
              <div class="margin-t-2 float-right pl-2 mr-2" v-if="subtasks.length > 0">
                <i class="fa fa-print cursor-pointer" aria-hidden="true" @click="printFunc()" style="font-size: 30px; padding-top: 0px; "></i>
              </div>
              <div class="margin-t-2 float-right pl-2 mr-2" v-if="subtasks.length > 0" @click="downloadFunc()">
                <img class="cursor-pointer" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px" style="padding-top: 2px; " />
              </div>
              <div class="clear"></div>
            </div>

          </div>

          <div class="clear"></div>

          <div class="border-bottom mt-1 mb-2"></div>

        <!-- Filter Section -->
        <div class="row" v-if="loading == false">
          <div class="col-md-12 offset-md-0">
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter</b-navbar-brand>
              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down "></i></b-navbar-toggle>
              <b-collapse id="nav-collapse" is-nav>
                <div class="search-wrapper col-12">
                  <div class="row col-12 override-padding pb-2 border-location">
                    <div class="col-3 pl-0">
                      <span class="cp-filter-label pr-2">Location:</span>
                      <b-form-select v-model="accountId" :options="report_all_locations" class="col-8 margin-bottom-10" style=" margin-top: 9px !important;" @change="updateAccountAction()" />
                    </div>
                    <div class="col-3">
                      <span class="cp-filter-label pr-2">User:</span>
                      <b-form-select v-model="rep_mentee" :options="menteeLists"  @change="updateMenteeTasklistAction()" class="col-8 margin-bottom-10" style=" margin-top: 9px !important;" />
                    </div>
                    <div class="col-3 pl-0">
                      <span class="cp-filter-label pr-2">Pathways:</span>
                      <b-form-select v-model="rep_pathway" :options="pathwayLists" @change="filterCompetency()" class="col-8 margin-bottom-10" style=" margin-top: 9px !important;" />
                    </div>
                    <div class="col-2 pr-0 text-right search-icon-wrapper cursor-pointer mt-1">
                      
                    </div>
                  </div>
                </div>
              </b-collapse>
            </b-navbar>
          </div>
        </div>

        <div class="clear"></div>


          <div class="row top-content" v-if="loading == true">
          <div class="col-3 p-0 pl-4" >
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-3 text-right p-0 pl-3">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-3 text-right p-0 pl-3">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-3 text-right p-0 pl-3 pr-3">
            <div class="col-9" >
              <PuSkeleton  height="30px" :count="1"></PuSkeleton>
            </div>
          </div>
          </div>











                <div class="col-md-12 mb-2" v-for="option in 3" v-if="loading == true">
                  <div class="col-md-8 offset-md-2 border shadow float-left subtask-list-layout pt-1 px-3 margin-t-10">
                    <div class="row row align-items-center">
                      <div class="col-7">
                        <div class="cp-title col-4 text-left" ><PuSkeleton :count="1" width=""></PuSkeleton></div>
                        <div class="cp-text col-7"><PuSkeleton :count="1"></PuSkeleton></div>
                        <div class="cp-text col-7"><PuSkeleton :count="1"></PuSkeleton></div>
                        <div class="cp-text col-7"><PuSkeleton :count="1"></PuSkeleton></div>
                        <div class="cp-text col-6"><PuSkeleton :count="1"></PuSkeleton></div>
                      </div>
                      <div class="col-5 text-right pad-right"> 
                        <PuSkeleton circle height="120px" width="120px" :count="1"></PuSkeleton>
                      </div>
                    </div>
                  </div>
                </div>








        <div class="col-md-12 mb-2">
          <div v-if="isOverviewVisible && loading == false" class="col-md-8 offset-md-2 border shadow float-left subtask-list-layout pt-1 px-3 margin-t-10">
            <div class="row align-items-center">
              <div class="col-7">
                <div class="cp-title text-left">Overview</div>
                <div class="cp-text">Total Tasks in List: {{ overviewTotalTaskCount }}</div>
                <div class="cp-text">Total Tasks Competent: {{ overviewTotalCompetentTaskCount }}</div>
                <div class="cp-text">Total Time Submitted: {{ calchoursonly(overviewTotaltime) }}</div>

                <div class="cp-text">
                Remaining Tasks: {{ overviewTotalRemainingTaskCount }}
                <a href="javascript:void(0);" class="ml-2 branding_text_color text-uppercase font-weight-bold" @click="displayOverviewRemainingTasks(overviewTotalRemainingTaskCount, overviewAllRemainingIds)">view all</a>
                </div>
              </div>
              <div class="col-5">                  
                <vc-donut
                  background="white" foreground="grey"
                  :size="100" unit="px" :thickness="30"              
                  :sections="chartDataItems" :total="100"
                  :start-angle="0" :auto-adjust-text-size="true" >
                <h1>{{competentPercentValue}}%</h1>
                </vc-donut>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
            <div class="clear"></div>

          <div class="">
              <div v-for="(subtask, sindex) in subtasks" class="col-md-12 mb-2" :key="sindex">
                  <div class="col-md-8 offset-md-2 shadow border float-left subtask-list-layout pt-1 px-3">
                  <div class="row align-items-center">
                      <div class="col-7">
                          <div class="cp-title text-left">{{ subtask.name }}</div>
                          <div class="cp-text">Total Tasks in Section: {{ subtask.subtask_total_stats.totalTaskCount }}</div>
                          <div class="cp-text">Total Tasks Competent: {{ subtask.subtask_total_stats.totalCompetentTaskCount }}</div>
                          <div class="cp-text">Total Time Submitted: {{ calchoursonly(subtask.totalTime) }}</div>
                          <div class="cp-text">
                          Remaining Tasks: {{ subtask.subtask_total_stats.totalRemainingTaskCount }}
                          <a href="javascript:void(0);" class="ml-2 branding_text_color text-uppercase font-weight-bold" @click="displayRemainingTasks(subtask.name, subtask.subtask_total_stats.totalRemainingTaskCount, subtask.subtask_total_stats.viewAllRemainingIds)">view all</a>
                          </div>
                      </div>
                      <div class="col-5">
                          <div class="cp-toggle-icon">
                              <b-link v-b-toggle="'collapse-' + subtask.id" @click="getFontIcon(subtask.id, sindex)">
                              <i class="fa fa-angle-down" :id="'angle-'+ subtask.id" aria-hidden="true"></i>
                              </b-link>
                          </div>
                                  <vc-donut
                                      background="white" foreground="grey"
                                      :size="100" unit="px" :thickness="30"              
                                      :sections="subtask.competent_percent" :total="100"
                                      :start-angle="0" :auto-adjust-text-size="true" >
                              <h1>{{subtask.competent_percent[0].value}}%</h1>
                              </vc-donut>
                          </div>
                      </div>
                      <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2">
                        <div v-show="subtask.loading"  class="col-12 text-center pt-4">
                          <div class="row my-3" v-for="option in 5">
                            <div class="col-12 px-3 heading-tasks">
                              <div class="col-9 text-muted"><PuSkeleton :count="1"></PuSkeleton></div>
                              <div class="col-3 float-right text-right pr-5"><PuSkeleton :count="1"></PuSkeleton></div>
                              <div style="clear: both;"></div>
                              <div class="col-4 float-right text-right pr-5 mb-3">
                                <PuSkeleton :count="1"></PuSkeleton>
                              </div>
                              <div style="clear: both;"></div>
                            </div>
                            <div class="col-12 p-0">
                              <div class="custom_hr"></div>
                            </div>
                          </div>
                        </div>
                        <div v-if="subtask.headings.length > 0" v-for="(heading, index) in subtask.headings" :key="index" class="cp-heading-lists">
                          <div v-if="heading.name != 'NULL' && heading.id != 99999">
                            <div class="row cp-heading-title">
                              <div class="col-12" style="font-size: 16px;">{{ heading.name }}</div>
                            </div>
                            <div class="row px-3 heading-tasks" v-if="heading.tasks.length > 0" v-for="(task, tindex) in heading.tasks" :key="tindex">
                              <div class="col-12 cp-task-desc">{{ (tindex + 1)  + '. ' + task.description }}</div>
                              <div :class="'col-12 ' + getRatedClass(task.three_plus_rated_count) + ' text-right pr-5'">{{ task.three_plus_rated_count }} Reps Rated 3+</div>
                              <div class="col-12 cp-see-all-reps text-right pr-5">
                                <a href="javascript:void(0);" @click="reportViewTaskRepitition(task.id, task.description, subtask.name, heading.name)" class="progress_item_link branding_text_color font-weight-bold">See All Task Reps <img  v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
                              </div>
                            </div>
                          </div>
                          <div v-else-if="heading.id != 99999" >
                            <div v-if="heading.tasks.length > 0">
                              <div class="row px-3 heading-tasks" v-for="(task, tindex) in heading.tasks" :key="tindex">
                                <div class="col-12 text-muted">{{ (tindex + 1)  + '. ' + task.description }}</div>
                                <div :class="'col-12 ' + getRatedClass(task.three_plus_rated_count) + ' text-right pr-5'">{{ task.three_plus_rated_count }} Reps Rated 3+</div>
                                <div class="col-12 cp-see-all-reps text-right pr-5">
                                  <a href="javascript:void(0);" @click="reportViewTaskRepitition(task.id, task.description, subtask.name, '')" class="progress_item_link branding_text_color font-weight-bold">See All Task Reps  <img  v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-collapse>  
                  </div>
                  <div class="clear"></div>
              </div>
          </div>
      </div>
                    <OverviewRemainingTasks
                        :isModalVisible="isOverviewRemainingModalVisible"
                        :tasklistId="taskListID"
                        ref="overview_tasks"
                        @close="isOverviewRemainingModalVisible = false">
                    </OverviewRemainingTasks>
                    <ViewRemainingTasks
                        :isModalVisible="isViewRemainingModalVisible"
                        :tasklistId="taskListID"
                        ref="remaining_tasks"
                        @close="isViewRemainingModalVisible = false">
                    </ViewRemainingTasks>
                    <EnterpriseAdminViewTaskRepitition
                        :isModalVisible="isReportViewTaskModalVisible"
                        :tasklistId="taskListID"
                        :menteeId="menteeId"
                        :paramAccountId="accountId"
                        ref="report_view_task_reps"
                        @close="isReportViewTaskModalVisible = false">
                    </EnterpriseAdminViewTaskRepitition>
                </div>
            </div>
        </div>
        
        <EnterpriseAdminOverlaySidebar
              :isModalVisible="isModalVisible" 
              @close="closeSidebar"
              ref="location_sidebar" 
              :readOnly="isReadOnly" 
             />


    <ShareReportModal :isModalVisible="isShareModalVisible" @close="isShareModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading ml-1"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding success_msg">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control input-height-35"                
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div class="clear margin-bottom-10"></div>


        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="btn col-3 input-height-25 ma-blue-btn"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              
              class="btn btn-dard-grey input-height-25 col-lg-3"
              ><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>




    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import store from '../../store/store.js';
import OverviewRemainingTasks from '../manager/overview_remaining_tasks.vue';
import ViewRemainingTasks from '../manager/view_remaining_tasks.vue';
import EnterpriseAdminViewTaskRepitition from "./enterpriseadmin_task_view_repitition.vue";
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
import ShareReportModal from '../enterpriseadmin/share_email_report_modal.vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.use(Donut);

export default {
    data() {
        return {
            loading: false,
            taskLists: [],
            pathwayLists: [], 
            rep_task_list: '',
            rep_pathway: '',
            menteeLists: [],
            rep_mentee: '',
            menteeId: '',
            taskListID: '',
            subtasks: [],
            rep_days: '',
            overviewTotalTaskCount: 0,
            overviewTotalCompetentTaskCount: 0,
            overviewTotalRemainingTaskCount: 0,
            overviewAllRemainingIds: [],
            chartDataItems: [],
            competentPercentValue: '',
            sections: [
                { label: 'Red section', value: 100, color: 'red' },
                { label: 'Green section', value: 0, color: 'green' }                
              ],
            headings: [],
            tasks: [],
            isOverviewRemainingModalVisible: false,
            isViewRemainingModalVisible: false,
            isReportViewTaskModalVisible: false,
            isOverviewVisible: false,
            accountId: '',
            isModalVisible: false,
            accountItems: [],
            report_all_locations: [],
            apiUrl: '',
            isShareModalVisible: false,
            submit_text: 'Submit',
            share_email: '',
            showOverlay: false,
            showWait: false,
            showShareSuccess: false,
            showOverlay: false,
            overviewTotaltime: '',
            page: 0,
            total_pages: 1,
            menteeName: '',
            userLists: [],
        }
    },
    components: {
        UserMenu,
        GoBack,
        OverviewRemainingTasks,
        ViewRemainingTasks,
        EnterpriseAdminViewTaskRepitition,
        EnterpriseAdminSidebarMenu,
        EnterpriseAdminOverlaySidebar,
        ShareReportModal,
    },
    computed: {
      isReadOnly(){
        if (this.$store.state.enterprise_type === 'Readonly') {
          return true;
        } else {
          if (this.$store.state.switch_admin_enterprise_isreadonly) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    methods: {
        previousPagination: function() {
          var count = parseInt(this.page) - parseInt(1);
          if(count >= 0) {
            this.page = count;
            let menteeId = this.userLists[this.page].id;
            this.rep_mentee = menteeId;
            this.pathwayLists = [];
            this.showTasksLists(this.rep_mentee);
          }
        },
        nextPagination: function() {
          var count = parseInt(this.page) + parseInt(1);
          if((count >= 0) && (count < this.total_pages)) {
            this.page = count;
            let menteeId = this.userLists[this.page].id;
            this.rep_mentee = menteeId;
            this.pathwayLists = [];
            this.showTasksLists(this.rep_mentee);
          }
        },
        backtoCompetencyReport() {
          let routeData = this.$router.resolve({path: '/enterprise-admin/competency-report-overview/All'});
          window.open(routeData.href, '_self');
        },
        getTaskListsHeadingLists(taskListId, index) {
          if(this.subtasks[index].headings.length >= 1) {
            this.subtasks[index].loading = false;
          } else {
            axios.get('/desktop-report/competency-report-getheadingslists/' + taskListId + '/' + this.menteeId + '/' + this.accountId, {
            })
            .then(response =>  {
              this.subtasks[index].loading = false;
              this.subtasks[index].headings = response.data.headingList;
            })
            .catch(error => {

            });
          }
        },
        calchoursonly: function(minutes) {
            var hours = (minutes / 60);
            var rhours = Math.floor(hours);
            var min = (hours - rhours) * 60;
            var rminutes = Math.round(min);
            if(rminutes > 0) {
                return rhours + " Hours " + rminutes + " Minutes ";
            }
            else {
                return rhours + " Hours ";
            }
        },
        navigate(path) {
            router.push(path);
        },
        printFunc: function() {
          this.showOverlay = true;
          if (this.rep_mentee) {
              this.menteeId = this.rep_mentee;
          }
          if (this.rep_pathway) {
              this.pathwayID = this.rep_pathway;
          }
          axios.get('/desktop-report/competency-report-pdf-for-pathway/' + this.pathwayID + '/' + this.menteeId + '/' + this.$store.state.user_accountid, {
          })
          .then(res =>  {
            this.pdf_file_name = res.data.pdf_file_name;
            this.showOverlay = false;
            fetch(this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name).then(function(response) {
                return response.blob();
            }).then(function(myBlob) {
                var objectURL = URL.createObjectURL(myBlob);
                document.querySelector('#pdf-frame').src = '';
                document.querySelector('#pdf-frame').src = objectURL;
                objectURL = URL.revokeObjectURL(myBlob);
            }).then(
                function() {
                    window.setTimeout(function() {
                        document.querySelector('#pdf-frame').contentWindow.print();
                    }, 1000)
                });
              return false;
          })
          .catch(function(error) {
              console.log(error);
          });
        },
        shareButtonSubmit: function() {
          this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              this.submit_text = 'Please wait...';
              this.showWait = true;
              if (this.rep_mentee) {
                  this.menteeId = this.rep_mentee;
              }
              if (this.rep_pathway) {
                  this.pathwayID = this.rep_pathway;
              }
              axios('/user-competency-report-email/' + this.pathwayID + '/' + this.menteeId + '/' + this.accountId,
                  {
                    method: 'POST',
                    data:
                    {
                      email: this.share_email,
                    },
                  }
                )
              .then((resp) => {
                this.share_email = '';
                this.submit_text = 'Submit';
                this.showWait = false;
                this.showShareSuccess = true;
                setTimeout(() => {
                    this.showShareSuccess = false;
                }, 5000)
                //this.isModalVisible = false;
                //this.$emit('close');

                })
              .catch(error => {

              });
            }
          });

        },
        shareButtonModal() {
          this.isShareModalVisible = true;
        },
        downloadFunc: function() {
            this.showOverlay = true;
            if (this.rep_mentee) {
                this.menteeId = this.rep_mentee;
            }
            if (this.rep_pathway) {
                this.pathwayID = this.rep_pathway;
            }
            axios.get('/desktop-report/competency-report-pdf-for-pathway/' + this.pathwayID + '/' + this.menteeId + '/' + this.accountId, {
            })
            .then(response =>  {
                this.pdf_file_name = response.data.pdf_file_name;
                this.showOverlay = false;
                var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
     
                //Create XMLHTTP Request.
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "blob";
                req.onload = function () {
                    //Convert the Byte Data to BLOB object.
                    var blob = new Blob([req.response], { type: "application/octetstream" });
     
                    //Check the Browser type and download the File.
                    var isIE = false || !!document.documentMode;
                    if (isIE) {
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        var url = window.URL || window.webkitURL;
                        var link = url.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.setAttribute("download", "competency_report.pdf");
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                };
                req.send();
                return false;
              })
              .catch(function(error) {
                  console.log(error);
              });


        },

        updateAccountAction() {
            router.push('/enterprise-admin/competency-report-overview/' + this.accountId);
        },
        showTasksLists(mentee_id) {
          this.loading = true;
            axios.get('/mobile/mentee/pathways?mentee_id=' + mentee_id, {
              params: {
                account_id: this.accountId,
              }
            })
            .then(response =>  {    
              this.menteeName = response.data.menteeName;
              var Lists = response.data.pathwayLists;
              console.log(Lists);
              for(var j=0; j<Lists.length; j++) {
                this.pathwayLists.push({
                  'value': Lists[j].value,
                  'text': Lists[j].display
                });
              }
              this.overviewTotaltime = '';
              this.overviewTotalTaskCount = 0;
              this.overviewTotalCompetentTaskCount = 0;
              this.overviewTotalRemainingTaskCount = 0;
              this.overviewAllRemainingIds = [];
              this.chartDataItems = [];
              this.subtasks = [];
              this.competentPercentValue = 0;
              if(this.pathwayLists.length > 0) {
                this.rep_pathway = this.pathwayLists[0].value;
                this.filterCompetency();
              }
              else {
                this.loading = false;
              }
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        getMenteesAction() {
            axios.get('/enteprise-admin/account_mentees_list/' + this.accountId, {        
            })
            .then(response =>  {     
                var Lists = response.data;
                this.userLists = [];
                this.menteeLists.push({
                'value': 'All',
                'text': 'All Users',
                });
                for(var i=0; i<Lists.length; i++) {
                  this.userLists.push({
                    'id': Lists[i].value,
                  });
                  this.menteeLists.push({
                  'value': Lists[i].value,
                  'text': Lists[i].display
                  });
                }
                if(this.menteeLists.length > 0) {
                  if(this.$route.query.mentee_id) {
                      this.rep_mentee = this.$route.query.mentee_id;
                  }
                  else {
                      this.rep_mentee = this.menteeLists[1].value;
                  }
                  this.total_pages = this.userLists.length;
                  console.log(this.userLists);
                  let index = this.userLists.findIndex(item => item.id == this.rep_mentee);
                  this.page = index;
                  axios.get('/mobile/mentee/pathways?mentee_id=' + this.rep_mentee, {
                      params: {
                        account_id: this.accountId,
                      }
                  })
                  .then(response =>  {    
                  this.pathwayLists = [];
                  var Lists = response.data.pathwayLists;
                  // console.log(Lists);
                  for(var j=0; j<Lists.length; j++) {
                      this.pathwayLists.push({
                      'value': Lists[j].value,
                      'text': Lists[j].display
                      });
                  }
                  if(this.pathwayLists.length > 0) {
                    if(this.$route.query.pathwayId) {
                      this.rep_pathway = this.$route.query.pathwayId;
                    }
                    else {
                      this.rep_pathway = this.pathwayLists[0].value;
                    }
                    this.filterCompetency();
                  }
                  
                  })
                  .catch(function(error) {
                      console.log(error);
                  });

                }
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        filterCompetency() {
            this.loading = true;
            if (this.rep_mentee) {
                this.menteeId = this.rep_mentee;
            }
            if (this.rep_pathway) {
                this.pathwayID = this.rep_pathway;
            }
            this.subtasks = [];

            axios.get('/desktop-report/mentee-tasklists-lists-competency-report/' + this.menteeId + '/' + this.pathwayID + '/' + this.accountId, {
            })
            .then(response =>  {
                if(response.data.length == 0) {
                    
                }
                else {
                    
                }
                this.isOverviewVisible = true;
                this.subtasks = response.data.taskList;
                // console.log(response)
            })
            .catch(function(error) {
                console.log(error);
            });
            axios.get('/desktop-report/mentee-tasklists-lists-competency-report-overivew/' + this.pathwayID + '/' + this.menteeId + '/' + this.accountId, {
            })
            .then(response =>  {
                this.loading = false; 
                // console.log(response)
                this.overviewTotaltime = response.data.totalTime;
                this.overviewTotalTaskCount = response.data.totalTaskCount;
                this.overviewTotalCompetentTaskCount = response.data.totalCompetentTaskCount;
                this.overviewTotalRemainingTaskCount = response.data.totalRemainingTaskCount;
                this.overviewAllRemainingIds = response.data.viewAllRemainingIds;
                this.chartDataItems = response.data.competent_percent;
                this.menteeName = response.data.menteeName;
                //alert(this.chartDataItems[0].value)
                this.competentPercentValue = this.chartDataItems[0].value;                
            })
            .catch(function(error) {
                console.log(error);
            });
        },

        updateMenteeTasklistAction: function() {           
            //this.loading = true;
            if(this.rep_mentee == 'All') {
                router.push('/enterprise-admin/competency-report-overview/' + this.accountId);
            }
            else {
                this.pathwayLists = [];
                let index = this.userLists.findIndex(item => item.id == this.rep_mentee);
                this.page = index;
                this.showTasksLists(this.rep_mentee);
            }
        },

        getRatedClass(count) {
            if (count > 2) {
                return 'cp-blue-reps';
            } else {
                return 'cp-gray-reps';
            }
        },
        reportViewTaskRepitition: function(taskId, taskDescription, subtaskName, headingName) {
            this.isReportViewTaskModalVisible = true;
            this.$refs.report_view_task_reps.getTaskItem(taskId, taskDescription, subtaskName, headingName);
        },
        displayRemainingTasks(subtaskTitle, remainingCount, remainingIds) {
            this.isViewRemainingModalVisible = true;
            this.$refs.remaining_tasks.getTaskItem(subtaskTitle, remainingCount, remainingIds);
        },
        displayOverviewRemainingTasks(remainingCount, remainingIds) {
            this.isOverviewRemainingModalVisible = true;
            this.$refs.overview_tasks.getTaskItem(remainingCount, remainingIds, this.rep_pathway);
        },
        getFontIcon(id, index) {
            if (document.getElementById('collapse-' + id).style.display == "") {
              document.getElementById('angle-'+ id).className = "fa fa-angle-down";
            } else {
              document.getElementById('angle-'+ id).className = "fa fa-angle-up";
              this.subtasks[index].loading = true;
              this.getTaskListsHeadingLists(id, index);
            }
        },
        goToLocationWindow() {
            router.push('/enterprise-admin-dashboard');
        },
        closeSidebar() {
            this.isModalVisible = false;
        }
    },
    created: function () {
        this.loading = true;
        this.apiUrl = process.env.API_ENDPOINT;
        this.accountId = this.$route.params.accountId;
        axios('/enterprise-admin/getAllLinkedLocations',
        {
            method: 'GET'
        })
        .then(response => {
          var Lists = response.data.locations;
          // console.log(Lists);
          this.report_all_locations.push({
          'value': 'All',
          'text': 'All Locations',
          });
          for(var j=0; j<Lists.length; j++) {
            this.report_all_locations.push({
            'value': Lists[j].id,
            'text': Lists[j].company_name,
            });
          }
        })
        .catch(() => {
        });
        this.getMenteesAction();
    }
}
</script>
<style scoped>
.back-btn-wrapper {
    width:100%;
    margin-left: 10px;
    margin-right: 0px;
}
.cp-text {
    font-size: 14px;
    padding: 2px 0px 2px 0px;
}
.cp-title {
    font-size: 16px;
    font-weight: bold;
    padding: 5px 0px 10px 0px;
}
.subtask-list-layout {
    background-color: #FFF;
    border-radius: 10px;
    padding: 10px 0 10px 10px;
    margin-bottom: 10px
}
.subtask-list-layout h1 {
    font-size: 18px;
    text-align: center;
    vertical-align: middle;
    margin-top: 25px;
}
.report-line-separator {
    border-bottom: 1px solid #A6A6A6;
}  
.cp-toggle-icon {
    text-align: right;
    font-size: 26px;
    font-weight: bold;
    margin-right: 10px;
    margin-top: -2px;
}
.cp-heading-lists .row{
    margin-bottom: 10px;
}
.cp-heading-title {
    color: #7F7F7F;
    font-size: 14px;
    font-weight: 900;
    padding: 0;
}
.cp-blue-reps {
    text-align: right;
    padding-right: 90px;
    margin-bottom: 5px;
}
.cp-gray-reps {
    color: #707070;
    text-align: right;
    padding-right: 90px;
    margin-bottom: 5px;
}
.cp-see-all-reps {
    color: #707070;
    text-align: right;
    padding-right: 70px;
    margin-bottom: 10px;
}
.cp-filter-label {
    font-weight: bold;
}
.cp-task-desc {
    padding:0 40px 0 50px;
    margin-bottom: 10px;
}
.modal-goback { font-size: 22px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
h1 {
    color: #707070;
}
.rep_audit_bg {
    background-color: #FFF;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 10px;
}
.rep_heading {    
    font-size: 15px;
    font-weight: 900;
    margin-bottom: 10px;
}
.filterBtn {
    display: flex;
    margin: 0 auto;
}
.cp-filter-label {
    font-weight: bold;
    padding: 0px;
    margin: 0 5px;
    vertical-align: middle;
}
.circle {
  background-color: #2EACEE;  
  border-radius: 50%;
  height: 36px;
  width: 36px;
  text-align: center;
}
.circle i {
  color: #FFF;  
  font-size: 24px;
  text-align: center;
  padding-top: 5px;
  padding-right: 2px;
}
.rounded-pill {
    padding-left: 3rem!important;
    padding-right: 3rem!important;
  
}
.heading-tasks {
  border-bottom: 1px solid #dee2e6 !important;
  margin-left: 5px;
  margin-right: 5px;
}
.container-wrapper .heading {
    font-size: 24px !important;
    font-weight: normal !important;
}
.success_msg {
  color: #68C47E; text-align: center; margin-bottom: 15px;
}
.btn-dard-grey {
  border-radius: 15px;  
}
.padding-left-300 {
  padding-left: 300px;
}
.view-report {
  margin-top: 2px; cursor: pointer; text-align: center;

}
.border-location {
  border-color: #ced4da;
}
.pad-right {
  padding-right: 50px;
}
#sidebar1 {
  min-width: 165px;
  max-width: 165px;
  background-color: #FFFFFF;
  min-height: 100vh;
  transition: opacity 2s linear;
  transform: translate(0);
  opacity: 1;
  padding-top: 105px;
  position: fixed;
}

@media (max-width: 1199.98px) {
  #sidebar1 {
    min-width: 145px;
    max-width: 145px;
  }
}
#sidebar1 ul li {
  padding: 0px 10px 0px 10px;
  display: block;
  color: #6c757d !important;
  margin-left: 5px;
}

.sidebar_view_mentee {
  min-width: 110px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/competency_report.vue